import type { Components } from '@mildang/mui';

const createLink = (): Components => ({
  MuiLink: {
    defaultProps: {
      underline: 'none',
    },
  },
});

export default createLink;
